import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
`;

export const ModalContent = styled.div`
    background: #282E33;
    border-radius: 8px;
    padding: 24px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

export const Title = styled.h3`
    color: #B6C2CF;
    margin: 0 0 16px 0;
    font-size: 16px;
    font-weight: 600;
`;

export const Message = styled.p`
    color: #B6C2CF;
    margin: 0 0 24px 0;
    font-size: 14px;
    line-height: 1.5;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

const BaseButton = styled.button`
    padding: 8px 16px;
    border-radius: 3px;
    border: none;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:focus {
        outline: 2px solid #4C9AFF;
        outline-offset: 1px;
    }
`;

export const CancelButton = styled(BaseButton)`
    background: transparent;
    color: #B6C2CF;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    &:active {
        background: rgba(255, 255, 255, 0.2);
    }
`;

export const DeleteButton = styled(BaseButton)`
    background: #FF5630;
    color: white;
    
    &:hover {
        background: #FF4D1F;
    }

    &:active {
        background: #FF3D0A;
    }
`;